import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const bprmFormApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadBprmForm: builder.query({
      query: (id) => (config.GetForm || "") + id,
    }),
    saveBprmForm: builder.mutation({
      query: (data) => ({
        url: config.SaveFormData,
        method: "POST",
        body: data,
      }),
    }),
    updateBprmForm: builder.mutation({
      query: (data) => ({
        url: config.UpdateApplicationData,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoadBprmFormQuery,
  useLazyLoadBprmFormQuery,
  useSaveBprmFormMutation,
  useUpdateBprmFormMutation,
} = bprmFormApiSlice;
